import React from 'react';
import Icon from './ui/Icon';

export interface ConfirmCardData {
  title: string;
  fields: { label: string; value: string }[];
  onConfirm: () => void;
  onEdit?: () => void;
  onCancel: () => void;
}

interface VoiceConfirmCardProps {
  data: ConfirmCardData;
  variant?: 'overlay' | 'inline';
}

const VoiceConfirmCard: React.FC<VoiceConfirmCardProps> = ({ data, variant = 'overlay' }) => {
  const wrapperClass = variant === 'inline' ? 'gva-confirm-inline' : 'gva-confirm-overlay';

  return (
    <div className={wrapperClass}>
      <div className="gva-confirm-card">
        <h3 className="gva-confirm-title">{data.title}</h3>
        <div className="gva-confirm-divider" />
        <div className="gva-confirm-fields">
          {data.fields.map((field) => (
            <div key={field.label} className="gva-confirm-row">
              <span className="gva-confirm-label">{field.label}</span>
              <span className="gva-confirm-value">{field.value}</span>
            </div>
          ))}
        </div>
        <div className="gva-confirm-divider" />
        <div className="gva-confirm-actions">
          <button type="button" className="gva-confirm-btn gva-confirm-btn-primary" onClick={data.onConfirm}>
            <Icon name="check" size={16} /> Looks good
          </button>
          {data.onEdit && (
            <button type="button" className="gva-confirm-btn gva-confirm-btn-secondary" onClick={data.onEdit}>
              <Icon name="edit" size={16} /> Edit details
            </button>
          )}
          <button type="button" className="gva-confirm-btn gva-confirm-btn-ghost" onClick={data.onCancel}>
            <Icon name="close" size={16} /> Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default VoiceConfirmCard;
